const editUserDrawer = {
  addQueueButton: 'UserManagement-EditUser-AddQueue',
  queueCard: 'UserManagement-EditUser-QueueCard',
  queueActionsButton: 'UserManagement-EditUser-QueueActions',
  addVmBoxButton: 'UserManagement-EditUser-AddVmBox',
  vmBoxCard: 'UserManagement-EditUser-VmBoxCard',
  vmBoxActionsButton: 'UserManagement-EditUser-VmBoxActions',
  seatLevelSection: 'UserManagement-EditUser-SeatLevelSection',
  suggestedAddressCard: 'UserManagement-EditUser-SuggestedAddressCard',
  phoneNumberSearch: 'UserManagement-EditUser-PhoneNumberSearch',
  phoneNumberTenantFilter: 'UserManagement-EditUser-PhoneNumberTenantFilter',
  inboundRecordingField: 'UserManagement-EditUser-InboundRecordingField',
  inboundAnnouncementField: 'UserManagement-EditUser-InboundAnnouncementField',
  outboundRecordingField: 'UserManagement-EditUser-OutboundRecordingField',
  outboundAnnouncementField:
    'UserManagement-EditUser-OutboundAnnouncementField',
  recordingSection: {
    excludedTag: 'UserManagement-EditUser-RecordingSection-ExcludedTag',
  },
} as const;

const editUserRecordingDrawer = {
  inboundRecordingSelect:
    'UserManagement-EditUserRecordingDrawer-InboundRecordingSelect',
  inboundAnnouncementSelect:
    'UserManagement-EditUserRecordingDrawer-InboundAnnouncementSelect',
  outboundRecordingSelect:
    'UserManagement-EditUserRecordingDrawer-OutboundRecordingSelect',
  outboundAnnouncementSelect:
    'UserManagement-EditUserRecordingDrawer-OutboundAnnouncementSelect',
} as const;

const userManagementPage = {
  searchInput: 'UserManagement-Search-Input',
  roleFilterButton: 'UserManagement-RoleFilterButton',
  seatLevelFilterButton: 'UserManagement-SeatLevelFilterButton',
  queueAssignmentFilterButton: 'UserManagement-QueueAssignmentFilterButton',
  downloadReportButton: 'UserManagement-DownloadReportButton',
} as const;

const bulkActions = {
  addQueueCheckbox:
    'UserManagement-BulkActions-AddQueueDrawer-addQueueCheckbox',
  removeQueueCheckbox:
    'UserManagement-BulkActions-AddQueueDrawer-removeQueueCheckbox',
  searchQueueInput:
    'UserManagement-BulkActions-AddQueueDrawer-searchQueueInput',
  selectUserCheckbox: 'UserManagement-BulkActions-selectUserCheckbox',
  editUsersDropdown: 'UserManagement-BulkActions-EditUsersDropdown',
  seatLevelSelect: 'UserManagement-BulkActions-SeatLevelSelect',
  billToTenantSelect: 'UserManagement-BulkActions-BillToTenantSelect',
  finalizingModal: 'UserManagement-BulkActions-FinalizingModal',
  errorModal: 'UserManagement-BulkActions-ErrorModal',
  errorModalRetryButton: 'UserManagement-BulkActions-ErrorModalRetryButton',
  missingSeatLevelModal: 'UserManagement-BulkActions-MissingSeatLevelModal',
  continueWithoutUsersButton:
    'UserManagement-BulkActions-continueWithoutUsersButton',
  editE911SuggestedAddress:
    'UserManagement-BulkActions-EditE911SuggestedAddress',
  didModal: 'UserManagement-DidModal',
  didSaveButton: 'UserManagement-DidSaveButton',
  didAccountFilterButton: 'UserManagement-DidAccountFilterButton',
  didAccountFilterApplyButton: 'UserManagement-DidAccountFilterApplyButton',
  didAccountFilterOptionsList: 'UserManagement-DidAccountFilteringOptionsList',
  didTenantTag: 'UserManagement-DidTenantTag',
  didResultsCheckbox: 'UserManagement-DidResultsCheckbox',
} as const;

const seatLevelEditor = {
  seatLevelSelect: 'seat-level-select',
  billToTenantSelect: 'bill-to-tenant-select',
};

export const userManagementLocators = {
  editUserDrawer,
  editUserRecordingDrawer,
  userManagementPage,
  bulkActions,
  seatLevelEditor,
};
